import * as React from "react";

import { Box, Typography } from "@material-ui/core";

import {
  useBranding,
  useOnboardingStatusContext,
  useRunOnce,
} from "client/hooks";
import { logAmplitudeEvent } from "client/lib/amplitude";
import { OnboardingStatus } from "client/lib/apt-merchant";

import { StatusLabel } from "../StatusLabel";
import { StatusStep } from "../StatusStep";
import { useStyles } from "../styles";
import { OnboardingStatusToCurrentStateMap, Status, StatusMap } from "../types";

const onboardingStatusToCurrentStateMap: OnboardingStatusToCurrentStateMap = {
  INELIGIBLE: "Done",
  NO_RECORD: "None",
  IN_PROGRESS: "None",
  IN_REVIEW: "Done",
  REQUIRES_ATTENTION: "Done",
  READY_TO_INSTALL: "Done",
  COMPLETE: "Done",
};

const getCurrentState = (onboardingStatus: OnboardingStatus): Status =>
  !["NO_RECORD", "IN_PROGRESS"].includes(onboardingStatus)
    ? "Done"
    : onboardingStatusToCurrentStateMap[onboardingStatus];

export const ApplyStep: React.FC = () => {
  const { brandTitle } = useBranding();
  const classes = useStyles();
  const { onboardingStatus } = useOnboardingStatusContext();

  const currentState = getCurrentState(onboardingStatus);

  const statusMap: StatusMap = {
    None: {
      className: classes.light,
    },
    InProgress: {
      className: classes.light,
    },
    Done: {
      className: classes.dark,
    },
    Paused: {},
    Reviewing: {},
    RequiresAttention: {},
    Declined: {},
  };

  useRunOnce(() => logAmplitudeEvent("STATUS_PAGE", "apply_step_card_loaded"));

  return (
    <StatusStep timeToFade={250} activeOnboardingStep="Apply">
      <Box
        alignItems="center"
        className={`${statusMap[currentState].className} ${classes.statusWrapper}`}
        display="flex"
        justifyContent="space-between"
        mb={2}
        p={2}
      >
        <Typography variant="h6">
          <strong>Apply to join {brandTitle}</strong>
        </Typography>
        <StatusLabel status={currentState} stepSpecificText={"Done"} />
      </Box>
    </StatusStep>
  );
};
